{
  "de": {
    "navbar": {
      "customer": {
        "after_care": "Nachbetreuung",
        "announcements": "Projekt-Updates",
        "dashboard": "Dashboard",
        "decisions": "Entscheidungen",
        "documents": "Dokumente",
        "inspirations": "Inspirationen",
        "installments": "Finanzen",
        "profile": "Ihr Profil",
        "projectinfo": "Informationen",
        "question_lists": "FAQ",
        "surveys": "Umfragen",
        "ticket": {
          "new": "Neue Konversation"
        },
        "tickets": "Konversationen",
        "units": "Gebäudeakte"
      },
      "employee": {
        "all_projects": "Projekte",
        "client": "Profil {client}",
        "contacts": "Kontakte",
        "customer": "Kunde",
        "dashboard": "Dashboard",
        "employee": "Teammitglied",
        "overview": "Übersicht",
        "partner": "Partner",
        "profile": "Ihr Profil",
        "project": {
          "after_care": "Nachbetreuung",
          "decisions": "Entscheidungen",
          "documents": "Dokumente",
          "email_conversations": "Eingehende E-Mails",
          "info": "Informationen",
          "installments": "Finanzen",
          "milestones": "Workflows",
          "news": "Neuigkeiten",
          "question_lists": "FAQs",
          "sales": "Verkauf",
          "surveys": "Umfragen",
          "tasks": "Aufgaben",
          "todos": "Aufgaben (alt)"
        },
        "projects": "Projekte",
        "ticket": {
          "new": "Neue Konversation"
        },
        "tickets": "Konversationen"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Primäre Navigation",
            "secondary": "Sekundäre Navigation"
          }
        }
      },
      "partner": {
        "contacts": "Kontakte",
        "dashboard": "Dashboard",
        "profile": "Ihr Profil",
        "project": {
          "after_care": "Nachbetreuung",
          "decisions": "Entscheidungen",
          "documents": "Dokumente",
          "tickets": "Konversationen"
        },
        "projects": "Projekte"
      },
      "topnavbar": {
        "company": "Organisation",
        "helpcenter": "Hilfecenter",
        "inviteManageMembers": "Mitglieder einladen und verwalten",
        "logout": "Abmelden",
        "profile": "Profil",
        "searchTeam": "Organisation durchsuchen",
        "selectTeam": "Organisation auswählen",
        "settings": "Einstellungen",
        "team": "Team"
      }
    }
  }
}
